import React, { useContext } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil } from "@fortawesome/pro-light-svg-icons/faPencil";

import MuiButton from "@material-ui/core/Button";
import { createStyles, Theme, withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";

import { useFormatMessage } from "@comparaonline/react-intl-hooks";

import { getConfig } from "../../../../../config/app";
import { AppContext } from "../../../../lib/appContext";
import { getQueryString, injectCurrentQueryString } from "../../../../core/helpers";
import { router } from "../../../../routes";
import { LandingContext } from "../../../products/context/landing";
import { Layout } from "./Layout";

const styles = ({ spacing }: Theme) =>
  createStyles({
    root: {
      padding: `${spacing.unit * 2}px ${spacing.unit * 3}px ${spacing.unit}px`
    }
  });
const Button = withStyles(styles)(MuiButton);

export interface IQuoteSummaryProps {
  appName: string;
  description: string;
  formURL?: string;
  title: string;
}

const EditForm: React.FC<IQuoteSummaryProps> = ({ appName, description, formURL, title }) => {
  const { formId } = useContext(LandingContext);
  const { businessUnitSlug } = useContext(AppContext);
  const { Link } = router;
  const useInternalLink = getConfig("appName") === appName || !formURL;
  const t = useFormatMessage();

  const internalLinkParams = {
    route: "quoteForm",
    params: { ...getQueryString(window.location.href), business: businessUnitSlug, formId },
    shallow: true,
    prefetch: true
  };

  const externalLinkParams = {
    href: injectCurrentQueryString(formURL as string)
  };

  return (
    <Layout>
      <Link {...(useInternalLink ? internalLinkParams : {})}>
        <Button {...(!useInternalLink ? externalLinkParams : {})} name={t("results.quote.edit")}>
          <Typography align={"center"} variant={"h6"} color={"primary"} gutterBottom={true}>
            {title}
            <FontAwesomeIcon icon={faPencil} transform={{ x: 5 }} title={"edit"} />
          </Typography>
          <Typography align={"center"} variant={"caption"} noWrap={true}>
            {description}
          </Typography>
        </Button>
      </Link>
    </Layout>
  );
};

export { EditForm };
